/**
 * チェックボックス単体
 */

import { ChangeEvent } from 'react';

type Props = {
  id?: string;
  name?: string;
  value?: string;
  checked: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
};

const Checkbox = ({ id, name, value, checked, onChange, disabled = false, className }: Props) => {
  return (
    <input
      id={id}
      type='checkbox'
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={className}
    />
  );
};

export default Checkbox;
